import { Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ISvereador, Vereador, VereadorDTO } from '../../../../typesSite/vereador/Vereador';
import { useAddVereadorMutation, useGetVereadorQuery } from './vereadorApiSlice';
import errorFormat from '../../../../utils/errorFormat';

export const VereadorCreate = () => {
  const [vereador, SetVereador] = useState<Vereador>(ISvereador);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createVereador, status] = useAddVereadorMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetVereadorQuery(id);
  useEffect(() => {
    if (data) {
      SetVereador(data);
    }
  }, [data, error, isFetching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    SetVereador(prev => ({
      ...prev,
      [name]: value.toUpperCase()
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const parms: VereadorDTO = {
      id: vereador.id || '',
      nome: vereador.nome,
      apelido: vereador.apelido || '',
      legislatura: vereador.legislatura || '',
      partido: vereador.partido || '',
      emExercicio: vereador.emExercicio || false
    };

    /*
    id?: string;
  nome: string;
  apelido?: string;
  legislatura?: string;
  partido?: string;
  emExercicio?: boolean;

*/

    await createVereador(parms);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: {
              xs: '100%', // 100% em telas pequenas
              sm: '90%', // 90% em telas médias ou maiores
              md: '90%',
              lg: '90%'
            },
            maxWidth: '1200px', // Limite opcional
            p: 2
          }}
        >
          <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
            {vereador.id ? 'Edição' : 'Inclusão'} no Cadastro de Vereador
          </Typography>

          <form onSubmit={handleSubmit} method="POST">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Nome:" name="nome" onChange={handleChange} size="small" inputProps={{ maxLength: 50 }} value={vereador.nome} />
                  <FormHelperText>{vereador.nome?.length}/50 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField label="Apelido" name="apelido" onChange={handleChange} size="small" inputProps={{ maxLength: 50 }} value={vereador.apelido} />
                  <FormHelperText>{vereador.apelido?.length}/50 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField label="Legislatura" name="legislatura" onChange={handleChange} size="small" inputProps={{ maxLength: 50 }} value={vereador.legislatura} />
                  <FormHelperText>{vereador.legislatura?.length}/50 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField label="Partido" name="partido" onChange={handleChange} size="small" inputProps={{ maxLength: 100 }} value={vereador.partido} />
                  <FormHelperText>{vereador.partido?.length}/100 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={vereador.emExercicio || false}
                      onChange={e =>
                        SetVereador(prev => ({
                          ...prev,
                          emExercicio: e.target.checked
                        }))
                      }
                      name="emExercicio"
                      color="primary"
                    />
                  }
                  label="Encontra-se em exercício?"
                />
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" gap={2}>
                  <Button type="submit" variant="contained" color="secondary">
                    Gravar
                  </Button>

                  <Button variant="contained" onClick={() => navigate(-1)}>
                    Voltar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
};
